// removed by extract-text-webpack-plugin
module.exports = {"container":"_26QD_q58j1fGE_F79Ow8Ki","component":"_2NOtyV9ZlrZeTwA6FFfNfc","icon":"wC0ZHlGU2IkARu2WSmZKV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Messages/RefreshMsgsButton/RefreshMsgsButton.css
// module id = 1304
// module chunks = 0